<app-header></app-header>
<div class="outlet-wrapper"  *ngIf="!authService.isLoggedIn; else home">
    <app-login-screen></app-login-screen>
</div>

<ng-template #home>
    <router-outlet></router-outlet>  
</ng-template>
